<template>
  <div 
    v-if="hasAnySocialLink" 
    class="flex items-center justify-center gap-4 py-4"
  >
    <a 
      v-if="lineOfficialAddress" 
      :href="lineOfficialAddress" 
      target="_blank"
      rel="noopener noreferrer"
      class="social-link"
    >
      <img 
        src="@/assets/line_img.png" 
        alt="LINE" 
        class="w-12 h-12 hover:opacity-80 transition-opacity"
      />
    </a>
        
    <a 
      v-if="googleMapUrl" 
      :href="googleMapUrl" 
      target="_blank"
      rel="noopener noreferrer"
      class="social-link"
    >
      <img 
        src="@/assets/googleMap_img.png" 
        alt="Google Map" 
        class="w-12 h-12 hover:opacity-80 transition-opacity"
      />
    </a>
    
    <a 
      v-if="storeFacebook" 
      :href="storeFacebook" 
      target="_blank"
      rel="noopener noreferrer"
      class="social-link"
    >
      <img 
        src="@/assets/facebook_img.png" 
        alt="Facebook" 
        class="w-12 h-12 hover:opacity-80 transition-opacity"
      />
    </a>
    
    <a 
      v-if="storeInstagram" 
      :href="storeInstagram" 
      target="_blank"
      rel="noopener noreferrer"
      class="social-link"
    >
      <img 
        src="@/assets/instagram.png" 
        alt="Instagram" 
        class="w-12 h-12 hover:opacity-80 transition-opacity"
      />
    </a>
    
    <a 
      v-if="storeOfficialWeb" 
      :href="storeOfficialWeb" 
      target="_blank"
      rel="noopener noreferrer"
      class="social-link"
    >
      <img 
        src="@/assets/office_web_img.png" 
        alt="官方網站" 
        class="w-12 h-12 hover:opacity-80 transition-opacity"
      />
    </a>
    
    <a 
      v-if="storeYoutube" 
      :href="storeYoutube" 
      target="_blank"
      rel="noopener noreferrer"
      class="social-link"
    >
      <img 
        src="@/assets/youtube_img.png" 
        alt="YouTube" 
        class="w-12 h-12 hover:opacity-80 transition-opacity"
      />
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'StoreSocialLinks',
  
  computed: {
    ...mapGetters('basic', [
      'lineOfficialAddress',
      'storeFacebook',
      'storeInstagram',
      'storeOfficialWeb',
      'storeYoutube',
      'googleMapUrl'
    ]),
    
    // 檢查是否有任何社群媒體連結
    hasAnySocialLink() {
      return !!(
        this.lineOfficialAddress ||
        this.storeFacebook ||
        this.storeInstagram ||
        this.storeOfficialWeb ||
        this.storeYoutube ||
        this.googleMapUrl
      )
    }
  }
}
</script>

<style scoped>
.social-link {
  display: inline-block;
  padding: 0px 8px;
}
</style>
